import React, { useState, useRef, useEffect } from "react";
import Navbar from "components/Navbars/AuthNavbar";
import Footer from "components/Footers/Footer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import BASE_URL from "components/BaseUrl/apiConfig";
import Swal from "sweetalert2";
import "react-block-ui/style.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "components/Expense/style.css";
import { Checkbox, DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import BlockUiOverlay from "./BlockUiOverlay";
import { start } from "@popperjs/core";
import { format, parse } from "date-fns";
import AgGrid from "components/AgGridReact/AgGridReact";

const Expense = () => {
  const [isChecked, setIsChecked] = useState(false);
  const history = useHistory();
  const userNameInputRef = useRef(null);
  const [currency, setCurrency] = useState("");
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [monthName, setMonthName] = useState(null);
  const [expenseData, setExpenseData] = useState({
    expenseDescritions: [],
    expenses: [],
    TotalDebited: 0,
    TotalCreated: 0,
    AvailableBalance: "",
  });

  const [fixedData, setFixeddData] = useState({
    TotalDebited: 0,
    TotalCreated: 0,
    AvailableBalance: "",
  });

  // const currentDate = new Date();
  const currentDate = new Date();
  const firstDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  const lastDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );
  const day = currentDate.getDate().toString().padStart(2, "0");
  const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
  const year = currentDate.getFullYear().toString();
  const formattedDate = `${day}/${month}/${year}`;
  const dropdownRef = useRef(null);
  const [SelectDate, setSelectedDate] = useState(currentDate);
  const [selectedExpenseType, setSelectedExpenseType] = useState("");
  const [defaultDescription, setDefaultDescription] = useState("");
  const [defaultType, setDefaultType] = useState(); // Set the default type to 'Credited'
  const [amount, setAmount] = useState("");
  const [subUserId, setuserid] = useState("");
  const [editExpenseId, setEditExpenseId] = useState(null);

  //aggrid
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);

  // Function to handle checkbox change
  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    if (checked) {
      const firstDayOfYear = new Date(currentDate.getFullYear(), 0, 1);
      // Calculate the last day of the current year
      const lastDayOfYear = new Date(currentDate.getFullYear(), 11, 31);

      fetchData(firstDayOfYear, lastDayOfYear);
    } else {
      fetchData(firstDayOfMonth, lastDayOfMonth);
    }
  };

  // get userid form local storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";
  let userTypeId = "";
  let userStoreName = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
    userTypeId = userData.userTypeId;
    userStoreName = userData.userName;
  }

  const [isOpen, setIsOpen] = useState(false);

  //Check localstorage null or not
  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  const handleDropdownToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (action) => {
    setIsOpen(false);
    if (action === "download") {
      handleDownloadPDF();
    } else if (action === "email") {
      handleEmailExpenseReport();
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      window.addEventListener("click", handleClickOutside);
    } else {
      window.removeEventListener("click", handleClickOutside);
    }

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    fetchData();

    //setStartDate(firstDayOfMonth);
    // setEndDate(lastDayOfMonth);
    setMonthName(currentDate.toLocaleDateString(undefined, { month: "long" }));

    // Fetch data with the current month's start and end dates
    fetchData(firstDayOfMonth, lastDayOfMonth);
  }, []);

  // Rest of the component...

  const fetchData = async (startDate, endDate) => {
    try {
      setLoading(true);
      // Format the start date and end date in "yyyy/MM/dd" format
      const formattedStartDate = startDate
        ? startDate.toLocaleDateString("en-CA").replace(/-/g, "/")
        : null;
      const formattedEndDate = endDate
        ? endDate.toLocaleDateString("en-CA").replace(/-/g, "/")
        : null;
      // Check if startDate and endDate are provided
      const apiUrl =
        startDate && endDate
          ? `${BASE_URL}/api/Expense/GetExpensebyUserId?orderId=${groupId}&userId=${userId}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`
          : `${BASE_URL}/api/Expense/GetExpensebyUserId?orderId=${groupId}&userId=${userId}`;

      const response = await fetch(apiUrl);

      if (!response.ok) {
        setLoading(false);
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      // if (startDate == null && endDate == null) {
      //     setFixeddData(data);
      // }

      // setExpenseData(data);

      setRowData(data.expenses);
      setColumnDefs([
        {
          field: "expenseDescType",
          headerName: "Expense Type",
          flex: 1,
        },
        {
          field: "description",
          headerName: "Description",
          flex: 1,
        },
        // {
        //   field: "expenses",
        //   headerName: "Expenses",
        //   valueFormatter: (p) => "₹" + p.value,
        //   flex: 1,
        // },
        {
          field: "expenses",
          headerName: "Expenses",
          valueFormatter: (p) => "₹" + p.value,
          flex: 1,
          comparator: (valueA, valueB) => {
            return valueA - valueB;
          },
        },
        {
          field: "date",
          headerName: "Date",
          valueFormatter: (p) => new Date(p.value).toLocaleString(),
          flex: 1,
        },
        {
          field: "balance",
          headerName: "Balance",
          valueFormatter: (p) => "₹" + p.value,
          flex: 1,
          comparator: (valueA, valueB) => {
            return valueA - valueB;
          },
        },
        {
          field: "userName",
          headerName: "User Name",
          flex: 1,
        },
        {
          field: "action",
          headerName: "Action",
          cellRenderer: (params) => {
            return (
              <div className="cell py-1 px-4 flex justify-end">
                {/* Edit Icon */}
                <img
                  src={require("assets/img/Editicon.png")}
                  alt="Edit"
                  title="Edit"
                  className="mr-2 cursor-pointer"
                  style={{ width: "20px" }}
                  onClick={() => handleEdit(params.data.expenseId)}
                />

                {/* Delete Icon */}
                <img
                  src={require("assets/img/deleteicon.png")}
                  alt="Delete"
                  title="Delete"
                  className="cursor-pointer"
                  style={{ width: "20px" }}
                  onClick={() => handleDelete(params.data.expenseId)}
                />
              </div>
            );
          },
          flex: 1,
          sortable: false,
        },
      ]);

      // Set the fetched data to a separate state variable based on condition
      if (startDate == null && endDate == null) {
        setFixeddData(data);
      } else {
        setExpenseData(data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        userNameInputRef.current.focus();
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        const data = await response.json();
        // Assuming the API response has a property called 'currency'
        setCurrency(data.currency);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrencyData();
  }, []); // The empty dependency array ensures that this effect runs only once when the component mounts

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!selectedExpenseType || !SelectDate || !amount) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong. ",
        text: "All fields are required!",
      });
      return;
    }
    // datetime format global
    var newdatetime = editExpenseId ? SelectDate : currentDate;

    // Convert b to ISO format (global format)
    const globalFormatDate = new Date(newdatetime).toISOString();

    // Add 5 hours 30 minutes (in milliseconds)
    const timeToAdd = 5 * 60 * 60 * 1000 + 30 * 60 * 1000;
    const newDate = new Date(new Date(globalFormatDate).getTime() + timeToAdd); // Add to the ISO date

    // console.log(newDate.toISOString());

    // Prepare the data to send to the API
    const formData = {
      expenseId: editExpenseId || 0, // Use editExpenseId for update, 0 for insert
      userId: editExpenseId > 0 ? subUserId : userId,
      expenseDescType: selectedExpenseType,
      description: defaultDescription,
      expenses: amount,
      expenseTypeId: defaultType.toString(),
      Date: newDate.toISOString(),
    };

    // Now, you can make the API call with the formData

    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/api/Expense/AddExpense`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        setLoading(false);
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Re-fetch data to get the latest expenses
      fetchData();
      // Fetch data with the current month's start and end dates
      fetchData(firstDayOfMonth, lastDayOfMonth);
      // Show success message
      const successMessage = editExpenseId
        ? "Transaction updated successfully!"
        : "Transaction added successfully!";
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: successMessage,
      });

      // Reset form fields after submission
      // setManualDescription('');
      setSelectedExpenseType("");
      setDefaultDescription("");
      setDefaultType("");
      setAmount("");
      setSelectedDate(currentDate);
      setEditExpenseId(null); // Reset editExpenseId after submission
      setLoading(false);
    } catch (error) {
      console.error("Error adding/updating expense:", error);
      // Show error message
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while processing the expense. Please try again later.",
      });
    }
  };

  const formatPayDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return ` ${day}/${month}/${year}`;
  };

  // const parseDateString = (dateString) => {
  //     const parts = dateString.split('-');
  //     if (parts.length === 3) {
  //         const year = parseInt(parts[0]);
  //         const month = parseInt(parts[1]) - 1; // Months are zero-based in JavaScript
  //         const day = parseInt(parts[2]);
  //         return new Date(year, month, day);
  //     }
  //     return null;
  // }

  const handleEdit = async (expenseId) => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/Expense/GetExpensebyUserIdandExpenseId?expenseId=${expenseId}&userId=${userId}&userTypeId=${userTypeId}`
      );

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(
          `HTTP error! Status: ${response.status}, Message: ${errorMessage}`
        );
      }

      const editExpenseData = await response.json();
      // console.log("editExpenseData", editExpenseData);
      const dateStr = editExpenseData.date;
      // const dateOnly = dateStr.split("T")[0];
      const dateOnly = dateStr; //"2024-12-04T05:08:56.77"

      const parsedDate = new Date(dateStr);
      // console.log("parsedDate", parsedDate);

      // Update the form fields with the fetched data
      setSelectedExpenseType(editExpenseData.expenseDescType);
      setDefaultDescription(editExpenseData.description);
      setAmount(editExpenseData.expenses);
      setDefaultType(editExpenseData.expenseTypeId);
      // setSelectedDate(dateOnly);
      setSelectedDate(parsedDate);
      setuserid(editExpenseData.userId);
      // Set the editExpenseId state to track the currently edited expense
      setEditExpenseId(expenseId);
    } catch (error) {
      console.error("Error fetching edit expense data:", error);

      // Check if the error message indicates "You can not update this data"
      if (error.message.includes("You can not update this transaction")) {
        // Display a user-friendly error message
        Swal.fire({
          icon: "error",
          title: "Sorry!",
          text: "You cannot update this transaction.",
        });
      } else {
        // Display a generic error message
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while fetching the edit expense data. Please try again later.",
        });
      }
    }
  };

  const handleDelete = async (expenseId) => {
    // Show confirmation dialog
    const result = await Swal.fire({
      title: "Delete Confirmation",
      text: "Are you sure to delete this Transaction?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Expense/DeleteExpensebyExpenseId?expenseId=${expenseId}&userId=${userId}&userTypeId=${userTypeId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          const errorMessage = await response.text();
          throw new Error(
            `HTTP error! Status: ${response.status}, Message: ${errorMessage}`
          );
        }

        // Re-fetch data to get the latest expenses
        fetchData();
        // Fetch data with the current month's start and end dates
        fetchData(firstDayOfMonth, lastDayOfMonth);
        // Show success message
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The Transaction has been deleted successfully.",
        });
      } catch (error) {
        console.error("Error deleting expense:", error);
        // Check if the error message indicates "You can not update this data"
        if (error.message.includes("You can not Delete this transaction")) {
          // Display a user-friendly error message
          Swal.fire({
            icon: "error",
            title: "Sorry!",
            text: "You can not Delete this transaction.",
          });
        } else {
          // Display a generic error message
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while fetching the edit expense data. Please try again later.",
          });
        }
      }
    }
  };

  // const handleDateRangeChange = (newDates) => {
  //     // Update start and end dates when the user selects a new date range
  //     setStartDate(newDates[0]);
  //     setEndDate(newDates[1]);
  // };

  const handleDownloadPDF = async () => {
    try {
      // User clicked "Yes," start loading UI
      setLoading(true, "Downloading...");

      // Format the start date and end date in "yyyy/MM/dd" format
      const formattedStartDate = startDate
        ? startDate.toLocaleDateString("en-CA").replace(/-/g, "/")
        : null;
      const formattedEndDate = endDate
        ? endDate.toLocaleDateString("en-CA").replace(/-/g, "/")
        : null;

      // Build the API URL with user ID and optional start/end date parameters
      let apiUrl = `${BASE_URL}/api/Expense/DownloadPDF?userId=${userId}`;
      if (formattedStartDate && formattedEndDate) {
        apiUrl += `&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
      }

      // Make an HTTP request to download the PDF
      const response = await fetch(apiUrl);

      // Check if the request was successful (status code 200)
      if (response.ok) {
        // Convert the response to a blob and create a download link
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Expense Report.pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } else {
        // Handle error response
        const errorMessage = await response.text();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to download PDF. ${errorMessage}`,
        });
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
      // Show error message
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while downloading the PDF. Please try again later.",
      });
    } finally {
      // Stop loading UI
      setLoading(false);
    }
  };

  const handleEmailExpenseReport = async () => {
    // Display a confirmation dialog using SweetAlert
    const result = await Swal.fire({
      title: "Confirmation!",
      text: "Are you sure you want to send expense report on email?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    });

    if (result.isConfirmed) {
      // User clicked "Yes," start loading UI
      setLoading(true, "Sending Email...");

      // Format the start date and end date in "yyyy/MM/dd" format
      const formattedStartDate = startDate
        ? startDate.toLocaleDateString("en-CA").replace(/-/g, "/")
        : null;
      const formattedEndDate = endDate
        ? endDate.toLocaleDateString("en-CA").replace(/-/g, "/")
        : null;

      // Build the API URL with user ID and optional start/end date parameters
      let apiUrl = `${BASE_URL}/api/Expense/SendExpensetDownloadPDF?userId=${userId}`;
      if (formattedStartDate && formattedEndDate) {
        apiUrl += `&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
      }

      try {
        // Make a request to the API endpoint for emailing the expense report
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        // Extract email information from the response
        const { email } = await response.json();
        // Handle success (you may want to show a success message to the user)
        console.log("Expense report emailed successfully!");
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Expense report has been successfully sent to ${email} `,
        });
      } catch (error) {
        // Handle errors (you may want to show an error message to the user)
        console.error("Error emailing expense report:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while emailing the expense report. Please try again later.",
        });
      } finally {
        // Stop loading UI
        setLoading(false);
      }
    }
  };

  // const handleIconClick = () => {
  //     const url = `/addexpensetype?expensedescTypeID=${expenseData.expenseDescritions.length > 0 ? expenseData.expenseDescritions[0].expensedescTypeID : ''}`;
  //     history.push(url);

  // };

  //
  // Check if availableBalance is greater than 0
  const isPositiveBalance = expenseData.availableBalance > 0;

  // Set the color dynamically based on the condition
  const balanceColor = isPositiveBalance ? "rgb(0, 0, 255)" : "red";

  const sortedExpenseTypes = expenseData.expenseDescritions
    .slice() // Create a copy to avoid modifying the original array
    .sort((a, b) => a.expenseTypeName.localeCompare(b.expenseTypeName));

  function formatDateToDDMMYYYY(dateString) {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    return formattedDate;
  }
  const gridOptions = {
    getRowStyle: (params) => {
      if (params.data.expenseDescType === "Debited") {
        return { backgroundColor: "#fadbd8" };
      }
      if (params.data.expenseDescType === "Created") {
        return { backgroundColor: "#d5f5e3" };
      }
      return null;
    },
  };

  const clearform = () => {
    setEditExpenseId(null);
    setSelectedExpenseType("");
    setDefaultDescription("");
    setAmount("");
    setDefaultType("1");
    const newDate = new Date();
    newDate.setDate(newDate.getDate());
    setSelectedDate(newDate);
  };

  return (
    <>
      <Navbar />
      <div className="cust-div min-h-content-minvh">
        <BlockUiOverlay visible={loading} />
        <div className="container-fluid mx-auto p-4">
          <div className="flex flex-wrap items-center mb-1">
            <h1 className="text-2xl font-bold">Expenses({currency})</h1>
            <div className="flex ml-3 lg:pl-4 lg:mb-0 lg:mr-4">
              <span className="mr-4 text-xl md:text-sm">
                <strong> Available Balance: </strong>
                <span style={{ color: balanceColor }}>
                  {fixedData.availableBalance}
                </span>{" "}
                |
              </span>
              <span className="mr-4 text-xl md:text-sm">
                <strong>Total Credited:</strong>{" "}
                <span style={{ color: "rgb(50, 205, 50)" }}>
                  {fixedData.totalCreated}
                </span>{" "}
                |
              </span>
              <span className="mr-4 text-xl md:text-sm">
                <strong>Total Debited:</strong>{" "}
                <span style={{ color: "orange" }}>
                  {fixedData.totalDebited}
                </span>
              </span>
            </div>
          </div>
          <div className="flex flex-col mb-1 lg:flex-row  justify-between">
            <div className="flex-shrink-0 mb-1 lg:mb-0 lg:mr-4">
              {startDate ? (
                <>
                  <span className="mr-4 text-lg md:text-sm">
                    <strong>
                      From {formatDateToDDMMYYYY(startDate)} To{" "}
                      {formatDateToDDMMYYYY(endDate)}{" "}
                      <i className="fas fa-arrow-right ml-1"></i>{" "}
                    </strong>
                  </span>

                  <span className="mr-4 text-lg md:text-sm">
                    <strong> Credited:</strong>{" "}
                    <span style={{ color: "rgb(50, 205, 50)" }}>
                      {expenseData.totalCreated}
                    </span>{" "}
                    |
                  </span>
                  <span className="mr-4 text-lg md:text-sm">
                    <strong>Debited:</strong>{" "}
                    <span style={{ color: "orange" }}>
                      {expenseData.totalDebited}
                    </span>
                  </span>
                </>
              ) : (
                <>
                  <span className="mr-4 text-lg md:text-sm">
                    {/* <strong>{monthName} {year} <i className="fas fa-arrow-right ml-1"></i> </strong> */}
                    <strong>
                      {" "}
                      {isChecked ? `${year}` : `${monthName} ${year}`}{" "}
                      <i className="fas fa-arrow-right ml-1"></i>{" "}
                    </strong>
                  </span>

                  <span className="mr-4 text-lg md:text-sm">
                    <strong> Credited:</strong>{" "}
                    <span style={{ color: "rgb(50, 205, 50)" }}>
                      {expenseData.totalCreated}
                    </span>{" "}
                    |
                  </span>
                  <span className="mr-4 text-lg md:text-sm">
                    <strong>Debited:</strong>{" "}
                    <span style={{ color: "orange" }}>
                      {expenseData.totalDebited}
                    </span>
                  </span>
                </>
              )}
            </div>
            <div className="flex-grow"></div>
            {/* Add by vikas */}
            {/* <Checkbox checked={isChecked} onChange={handleCheckboxChange}>All</Checkbox>&nbsp;&nbsp;&nbsp; */}
            <label className="mt-1">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              &nbsp;&nbsp;
              <b>All</b>
            </label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <DateRangePicker
              size="md"
              format="dd/MM/yy"
              character=" – "
              placeholder="Select Date Range"
              style={{ marginRight: "10px", width: "200px" }}
              showOneCalendar
              onChange={(value) => {
                if (value === null) {
                  setStartDate(null);
                  setEndDate(null);
                  // If the date range is cleared (close button clicked)
                  const currentDate = new Date();
                  const firstDayOfMonth = new Date(
                    currentDate.getFullYear(),
                    currentDate.getMonth(),
                    1
                  );
                  const lastDayOfMonth = new Date(
                    currentDate.getFullYear(),
                    currentDate.getMonth() + 1,
                    0
                  );
                  setStartDate(null);
                  setEndDate(null);
                  // Fetch data with the current month's start and end dates
                  fetchData(firstDayOfMonth, lastDayOfMonth);
                  // fetchData();
                } else {
                  setStartDate(value[0]);
                  setEndDate(value[1]);
                  // Fetch data with the selected date range
                  fetchData(value[0], value[1]);
                }
              }}
            />
            {/* here is the code of dropdown */}
            <div className="relative flex text-left" ref={dropdownRef}>
              <div>
                <button
                  type="button"
                  className="bg-lightBlue-500 text-white px-4 py-2 rounded-sm"
                  id="options-menu"
                  aria-haspopup="true"
                  aria-expanded="true"
                  onClick={handleDropdownToggle}
                >
                  Expense Report
                  <span className="ml-1 text-sm">▼</span> {/* Small V icon */}
                </button>
              </div>

              {isOpen && (
                <div
                  className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="options-menu"
                >
                  <div className="py-1 " role="none">
                    <button
                      onClick={() => handleOptionClick("download")}
                      className="block tbl w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                      role="menuitem"
                    >
                      Download Expense Report
                    </button>
                    <button
                      onClick={() => handleOptionClick("email")}
                      className="block tbl w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                      role="menuitem"
                    >
                      Email Expense Report
                    </button>
                  </div>
                </div>
              )}
            </div>
            <style>{`
                                .tbl:hover{
                                    color:gray
                                }
                                `}</style>
            <BlockUiOverlay visible={loading} />
          </div>

          <div className="grid grid-cols-1 gap-4" style={{ marginTop: "10px" }}>
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-2">
                  <select
                    className="custom-height !w-full !border-2 border-blueGray-300 rounded-sm"
                    id="ExpenseDesctype"
                    ref={userNameInputRef}
                    style={{ width: "180px" }}
                    onChange={(e) => {
                      const selectedType = e.target.value;
                      setSelectedExpenseType(selectedType);

                      // Find the selected type in the expenseData and set default values
                      const selectedTypeData =
                        expenseData.expenseDescritions.find(
                          (type) => type.expenseTypeName === selectedType
                        );
                      if (selectedTypeData) {
                        setDefaultDescription(selectedTypeData.defaulttext);
                        setDefaultType(selectedTypeData.expenseTypeId);
                      }
                      if (selectedType === "__addNewExpense__") {
                        history.push("/addexpensetype");
                      }
                    }}
                    value={selectedExpenseType}
                  >
                    <option value="">Select Expense Type</option>
                    {sortedExpenseTypes.map((expenseDesc) => (
                      <option
                        key={expenseDesc.id}
                        value={expenseDesc.expenseTypeName}
                      >
                        {expenseDesc.expenseTypeName}
                      </option>
                    ))}
                    {userTypeId != 3 ? (
                      <option
                        value="__addNewExpense__"
                        style={{
                          background: "green",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Add New Expense Type
                      </option>
                    ) : null}
                  </select>
                </div>
                <div className="col-span-2">
                  <input
                    type="text"
                    className="form-control custom-height !w-full !border-2 border-blueGray-300 rounded-sm"
                    placeholder="Description"
                    maxLength={150}
                    id="Description"
                    style={{ width: "350px" }}
                    value={defaultDescription}
                    onChange={(e) => setDefaultDescription(e.target.value)}
                  />
                </div>
                <div className="col-span-2">
                  <input
                    type="text"
                    className="form-control custom-height !w-full !border-2 border-blueGray-300 rounded-sm"
                    placeholder={`Amount (${currency})`}
                    id="Expense"
                    maxLength={7}
                    style={{ width: "250px" }}
                    value={amount}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(
                        /[^0-9]/g,
                        ""
                      );
                      setAmount(numericValue);
                    }}
                  />
                </div>
                <div className="col-span-2">
                  <select
                    className="custom-height !w-full !border-2 border-blueGray-300 rounded-sm"
                    id="Type"
                    value={defaultType}
                    onChange={(e) => setDefaultType(e.target.value)}
                  >
                    <option value="1">Credited</option>
                    <option value="2">Debited</option>
                  </select>
                </div>
                <div className="col-span-2">
                  <DatePicker
                    selected={new Date(SelectDate)}
                    onChange={(date) => setSelectedDate(date)}
                    className="form-control !w-full custom-height !border-2 border-blueGray-300 rounded-sm"
                    dateFormat="dd/MM/yyyy h:mm aa"
                    showTimeSelect
                    timeFormat="HH:mm"
                    maxDate={currentDate}
                    timeIntervals={15}
                    style={{ zIndex: 9999, width: "100px" }}
                  />
                </div>
                <div className="col-span-2 flex space-x-4">
                  <button
                    className="text-white !w-1/2 py-2 bg-blue-500 text-xs font-bold uppercase shadow hover:shadow-lg transition-all duration-150 custom-button rounded-sm !h-9"
                    type="submit"
                    // style={{ height: "35px" }}
                    title={editExpenseId ? "Update Expense" : "Add New Expense"}
                  >
                    {editExpenseId ? "Update" : "Add"}
                  </button>
                  <button
                    type="button"
                    className="!bg-red-500 !w-1/2 py-2 font-medium custom-button h-9 text-white"
                    onClick={clearform}
                  >
                    Cancel
                  </button>
                </div>
              </div>
              {/* <div className="flex justify-between md:flex-row w-full flex-nowrap items-center gap-4"></div> */}
            </form>
          </div>
          {/* //ag grid */}
          <div className="overflow-x-auto" style={{ marginTop: "20px" }}>
            <div style={{ width: "100%", height: "100%" }} className="d-none">
              <div
                style={{ width: "100%", height: "100%" }}
                className={"ag-theme-quartz-dark"}
              >
                <AgGrid
                  RowData={rowData}
                  ColumnDefs={columnDefs}
                  gridOptions={gridOptions}
                />
              </div>
            </div>
            <table className="w-full min-w-full border cust-table">
              <thead>
                <tr className="border-b bg-lightBlue-500 text-white">
                  <th className="cell py-2 px-4 font-bold text-left">Type</th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Expense Description
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Amount({currency})
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">Date</th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Balance
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Added By
                  </th>
                  <td className="cell py-2 px-4 font-bold text-end">Actions</td>
                </tr>
              </thead>
              <tbody>
                {expenseData &&
                expenseData.expenses &&
                expenseData.expenses.length > 0 ? (
                  expenseData.expenses.map((expense) => (
                    <tr
                      key={expense.expenseId}
                      className={`cust-row`}
                      style={{
                        backgroundColor:
                          expense.expenseTypeId === "Cr."
                            ? "#D5F5E3 "
                            : "#FADBD8",
                      }}
                    >
                      <td className="cell py-1 px-4 text-left">
                        {expense.expenseTypeId === "Cr." ? (
                          <i className="fas fa-arrow-up text-emerald-500 mr-1 "></i>
                        ) : (
                          <i className="fas fa-arrow-down text-red-500 mr-1"></i>
                        )}

                        {expense.expenseDescType}
                      </td>
                      <td
                        className="cell py-1 px-4 text-left"
                        title={expense.description}
                      >
                        {expense.description.length > 80
                          ? `${expense.description.substring(0, 80)}...`
                          : expense.description}
                      </td>

                      <td className="cell py-1 px-4  text-left">
                        {expense.expenses}
                      </td>
                      <td className="cell py-1 px-4  text-left">
                        {formatPayDate(expense.date)}
                      </td>
                      <td className="cell py-1 px-4 text-left">
                        {expense.balance}
                      </td>
                      <td className="cell py-1 px-4  text-left">
                        {expense.userName}
                      </td>

                      <td className="cell py-1 px-4   flex justify-end">
                        {/* Edit Icon */}
                        <img
                          src={require("assets/img/Editicon.png")}
                          alt="Edit"
                          title="Edit"
                          className="mr-2 cursor-pointer"
                          style={{ width: "20px" }}
                          onClick={() => handleEdit(expense.expenseId)}
                        />

                        {/* Delete Icon */}
                        <img
                          src={require("assets/img/deleteicon.png")}
                          alt="Delete"
                          title="Delete"
                          className="cursor-pointer"
                          style={{ width: "20px" }}
                          onClick={() => handleDelete(expense.expenseId)}
                        />

                        {/* Edit Icon */}
                        {/* <img
                                                    src={require('assets/img/Editicon.png')}
                                                    alt="Edit"
                                                    className="mr-2 cursor-pointer"
                                                    style={{ width: '20px' }}
                                                    onClick={() => handleEdit(expense.expenseId)}
                                                /> */}

                        {/* Delete Icon */}
                        {/* <img
                                                    src={require('assets/img/deleteicon.png')}
                                                    alt="Delete"
                                                    className="cursor-pointer"
                                                    style={{ width: '20px' }}
                                                    onClick={() => handleDelete(expense.expenseId)}
                                                /> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="8"
                      className="text-center text-lg text-gray-900 mt-4"
                    >
                      No expenses recorded for this month.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Expense;
